/**
 * Storage Module
 *
 * Web storage abstraction using localStorage/sessionStorage
 * Replaces mobile's MMKV storage
 */

export { webStorage, storage } from './web-storage';
export type { WebStorage } from './web-storage';
export { getApolloCacheStorage } from './apollo-cache-storage';
